module.exports = __webpack_public_path__ + "assets/cb969d387ed8f949e79103abc7aa3f39.png";